<app-smart-diagnosis-pest-component type="Pests"></app-smart-diagnosis-pest-component>